// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LightBoxPreview_wrapper__27TrY","thumbnail":"LightBoxPreview_thumbnail__3PYXO","hoverImage":"LightBoxPreview_hoverImage__1O3r_","btn":"LightBoxPreview_btn__1NTdI"};